__turbopack_context__.v({
  "root": "DutpTa_root",
});
